'use client';
import React, { useState } from 'react';
import Head from 'next/head';
import Link from 'next/link';

const sections = [
  {
    title: "Consent",
    content:
      "By using our website, you hereby consent to our Privacy Policy and agree to its terms.",
  },
  {
    title: "Collection of Information",
    content:
      `The personal information that you are asked to provide, and the reasons why you are asked to provide it, will be made clear to you at the point we ask you to provide your personal information.
      
      If you contact us directly, we may receive additional information about you such as your name, email address, phone number, the contents of the message and/or attachments you may send us, and any other information you may choose to provide.

When you register for an Account, we may ask for your contact information, including items such as name, company name, address, email address, and telephone number.
      
      `,
  },
  {
    title: "Use of Information",
    content:
      `We use the information we collect in various ways, including to:

Provide, operate, and maintain our website`,
  },
  {
    title: "Log Files",
    content:
      "Vilva Business follows a standard procedure of using log files. These files log visitors when they visit websites. All hosting companies do this and a part of hosting services’ analytics. The information collected by log files include internet protocol (IP) addresses, browser type, Internet Service Provider (ISP), date and time stamp, referring/exit pages, and possibly the number of clicks. These are not linked to any information that is personally identifiable. The purpose of the information is for analyzing trends, administering the site, tracking users’ movement on the website, and gathering demographic information.",
  },
  {
    title: "Cookies and Web Beacons",
    content:
      "Like any other website, Vilva Business uses ‘cookies’. These cookies are used to store information including visitors’ preferences, and the pages on the website that the visitor accessed or visited. The information is used to optimize the users’ experience by customizing our web page content based on visitors’ browser type and/or other information.",
  },
  {
    title: "Google DoubleClick DART Cookie",
    content:
      "Google is one of a third-party vendor on our site. It also uses cookies, known as DART cookies, to serve ads to our site visitors based upon their visit to www.vilvabusiness.com and other sites on the internet. However, visitors may choose to decline the use of DART cookies by visiting the Google ad and content network Privacy Policy at the following URL – https://policies.google.com/technologies/ads",
  },
  {
    title: "Our Advertising Partners",
    content:
      "Some of advertisers on our site may use cookies and web beacons. Our advertising partners are listed below. Each of our advertising partners has their own Privacy Policy for their policies on user data. For easier access, we hyperlinked to their Privacy Policies below.",
  },
  {
    title: "Advertising Partners Privacy Policies",
    content:
      `You may consult this list to find the Privacy Policy for each of the advertising partners of Vilva Business.

Third-party ad servers or ad networks use technologies like cookies, JavaScript, or Web Beacons that are used in their respective advertisements and links that appear on Vilva Business, which are sent directly to users’ browser. They automatically receive your IP address when this occurs. These technologies are used to measure the effectiveness of their advertising campaigns and/or to personalize the advertising content that you see on websites that you visit.

`,
  },
];

const PrivacyPolicy = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggleSection = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <>
      <div className=' bg-[linear-gradient(180deg,_#EEF3FF_0%,_#FFF_26.53%)]'>


      <div className="max-w-2xl mx-auto px-4 py-[50px] text-[#1f1f1f]">
        <h1 className="text-[color:var(--Dark-Color,#090D28)]  text-center mb-[40px] font-Schibsted_Grotesk text-[32px] md:text-[40px] not-italic font-black leading-[120%]">Privacy Policy</h1>
        <p className="text-[#373844] font-Schibsted_Grotesk mb-[40px] text-[14px] md:text-[16px] not-italic font-normal leading-[150%]">
Vilva Business is committed to protecting the privacy of our customers, partners, and other stakeholders. This Privacy Policy explains how we collect, use, disclose, and protect information that we obtain from you through our website and other services.
        </p>
        <p className="text-[#373844] font-Schibsted_Grotesk mb-[24px] text-[14px] md:text-[16px] not-italic font-normal leading-[150%]">
This Privacy Policy applies only to our online activities and is valid for visitors to our website with regards to the information that they shared and/or collect in Vilva Business. This policy is not applicable to any information collected offline or via channels other than this website.
        </p>

        {sections.map((section, index) => (
          <div key={index}     className={`border-t py-[24px] ${index === sections.length - 1 ? 'border-b' : ''}`}>
            <div
              role="button"
              tabIndex={0}
              aria-expanded={openIndex === index}
              aria-controls={`privacy-panel-${index}`}
              onClick={() => toggleSection(index)}
              onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleSection(index); } }}
              className="flex justify-between items-center cursor-pointer"
            >
              <h2 className="text-[color:var(--Dark-Color,#090D28)] font-Schibsted_Grotesk text-[20px] md:text-[24px] not-italic font-black leading-[100%]">{section.title}</h2>
              <span aria-hidden="true" className="flex w-[32px] h-[32px] p-[6px] justify-center items-center aspect-square rounded-[6px] bg-[#EFF4FF]">
                {openIndex === index ? <svg className={`transform transition-transform duration-300 ${
      openIndex !== index ? 'rotate-0' : 'rotate-180'
    }`} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M4.16602 10H15.8327" stroke="#195AFF" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
</svg> : <svg className={`transform transition-transform duration-300 ${
      openIndex === index ? 'rotate-90' : 'rotate-0'
    }`} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M4.16602 10H15.8327" stroke="#195AFF" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
  <path d="M10 4.16667V15.8333" stroke="#195AFF" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
</svg>}
              </span>
            </div>

            <div
              id={`privacy-panel-${index}`}
              className={`overflow-hidden transition-all duration-300 ease-in-out ${
                openIndex === index ? 'max-h-[1000px] mt-2' : 'max-h-0'
              }`}
            >
              <p className="text-[#373844] font-Schibsted_Grotesk text-[14px] md:text-[16px] not-italic font-normal leading-[150%]">{section.content}</p>
            </div>
          </div>
        ))}


<div className='mt-[80px] flex items-center justify-center gap-[16px] flex-wrap'>
  <Link className="text-[color:var(--Main-colour,#195AFF)] font-Schibsted_Grotesk text-[14px] not-italic font-normal leading-[120%] !underline" href={'/privacy-policy'}>Privacy Policy</Link>
  <Link className="text-[color:var(--Main-colour,#195AFF)] font-Schibsted_Grotesk text-[14px] not-italic font-normal leading-[120%] !underline" href={'/terms-and-condition'}>Other Policies</Link>
  <Link className="text-[color:var(--Main-colour,#195AFF)] font-Schibsted_Grotesk text-[14px] not-italic font-normal leading-[120%] !underline" href={'/cookie-policy'}>Cookie Policy</Link>

</div>

        
      </div>

<div className='bg-[#01001E] py-[60px] md:py-[120px] flex items-center justify-center'>

<div>
  <h3 className="text-white font-NeueMontreal  text-center text-[32px] md:text-[48px] not-italic font-normal leading-[120%]">Always <span className="text-transparent bg-[linear-gradient(90deg,_#15BDFF_20.57%,_#C05DF2_54.45%)] bg-clip-text font-NeueMontreal  text-[32px] md:text-[48px] not-italic font-normal leading-[120%]"
>On Schedule </span>  always <span className="text-transparent mb-[16px] bg-[linear-gradient(90deg,_#15BDFF_20.57%,_#C05DF2_54.45%)] bg-clip-text font-NeueMontreal  text-[32px] md:text-[48px] not-italic font-normal leading-[120%]"
>Reliable</span> </h3>

  <p className="text-[#DADAE4] text-center mb-[24px] font-Schibsted_Grotesk text-[16px] md:text-[18px] not-italic font-normal leading-[150%]">Our team ensures timely results without compromising quality</p>

  <Link className="rounded-[8px] w-fit bg-[var(--Main-colour,#195AFF)] mx-auto flex h-[48px] px-[32px] py-[16px] justify-center items-center text-white font-LatinkaMedium text-[18px] not-italic font-normal leading-[120%]"
 href={'/book-demo'}> Book Free Demo </Link>
</div>
</div>

      </div>

    </>
  );
};

export default PrivacyPolicy;
